import { jsx as _jsx } from "react/jsx-runtime";
import get from 'lodash/get';
import difference from 'lodash/difference';
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import { useAction } from 'hooks';
import Visit, { VisitHistoryModal } from 'modules/Visit';
import Account from 'modules/Account';
import Hcp from 'modules/Hcp';
import CloudDrive from 'modules/CloudDrive';
const HcpVisitHistoryModal = ()=>{
    const { selectors: profileSelectors } = useContext(ProfileContext);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const activePatient = useSelector(Hcp.selectors.activePatient);
    const phiSetDocumentId = useSelector(Hcp.selectors.phiSetDocumentId);
    useSelector(Hcp.selectors.notes);
    const notesBatchesIndex = useSelector(Hcp.selectors.notesBatchesIndex);
    const sharingRequest = useSelector(Hcp.selectors.sharingRequest);
    const phiSet = useSelector(profileSelectors.phiSet);
    const activeVisit = useSelector(Visit.selectors.activeVisit);
    const fetchNotes = useAction(CloudDrive.actions.fetchNotes);
    const storeAndPushNotes = useAction(Hcp.actions.storeAndPushNote);
    const { passphrase } = activeClinicMembership || {};
    const onStoreAndPushNotes = (newNotes, newPhiSet, newPhiSetDocumentId, phisetVisitId)=>{
        storeAndPushNotes(newNotes, newPhiSet, newPhiSetDocumentId, phisetVisitId, sharingRequest, activePatient, activeClinicMembership);
    };
    const onFetchNotes = (visit)=>{
        const associatedNotesBatches = get(visit, 'associatedDataIndexKeys.notes', []);
        const diff = difference(associatedNotesBatches, notesBatchesIndex);
        if (!diff.length) {
            return;
        }
        const { phiSetReferenceKey, accessToken, storageProvider } = activePatient || {};
        fetchNotes({
            phiSet,
            phiSetReferenceKey,
            phiSetDocumentId,
            notesBatchesIndex,
            accessToken,
            storageProvider,
            batches: associatedNotesBatches,
            successAction: Hcp.actions.setNotes
        });
    };
    const onResumeVisit = ()=>{
        if (!activeVisit) {
            return;
        }
        onFetchNotes(activeVisit);
    };
    useEffect(()=>{
        if (activeVisit) {
            onResumeVisit();
        }
    }, [
        activeVisit
    ]);
    useEffect(()=>{
        onResumeVisit();
    }, [
        activePatient
    ]);
    return passphrase ? /*#__PURE__*/ _jsx(VisitHistoryModal, {
        mode: "HCP",
        onFetchNotes: (visit)=>onFetchNotes(visit),
        onStoreNotes: (newNotes, newPhiSet, newPhiSetDocumentId, phisetVisitId)=>onStoreAndPushNotes(newNotes, newPhiSet, newPhiSetDocumentId, phisetVisitId)
    }) : null;
};
export default HcpVisitHistoryModal;
